import MemoControllerBox from '@Local/Components/MemoControllerBox';
import { Box, Stack } from '@curves/ui-base';

import { formatCurrencyFn } from '@Util/utils';
import React from 'react';
// 交易失敗名單
export const getCyclePurchaseBillingForFailureRowLabel = (billingCycle) => {
    return [
        {
            cellKey: 'cycleOrderNo',
            headerLabel: '主單編號',
            align: 'center',
        },
        {
            cellKey: 'contactResult',
            headerLabel: '交易結果',
            formatCell: (cellValue) => {
                return <MemoControllerBox data={cellValue} dialogTitle={'交易結果'} />;
            },
        },
        {
            cellKey: 'memberName',
            headerLabel: '會員',
            formatCell: (memberName, { memberNo }) => {
                return memberName ? (
                    <Stack direction={'column'}>
                        <Box className={'mb-1'}>{memberName}</Box>
                        <Box>{memberNo}</Box>
                    </Stack>
                ) : (
                    <Stack direction={'column'}>
                        <Box className={'font-color-3'}>無法取得對應會員</Box>
                    </Stack>
                );
            },
        },
        {
            cellKey: 'memberCellPhone',
            headerLabel: '手機',
        },
        {
            cellKey: 'transactionPrice',
            headerLabel: '訂單金額',
            formatCell: (cellValue) => {
                return formatCurrencyFn(cellValue, { symbol: '$' });
            },
        },
    ];
};
